<template>
  <div class="relative overflow-hidden border-b border-white/10 bg-neutral-900">
    <!-- purple light source -->
    <div
      class="bg-secondary-600/30 pointer-events-none absolute top-1/2 -left-[1%] size-[280px] -translate-y-1/2 rounded-full blur-[130px]"
      aria-hidden="true"
    />
    <div
      class="bg-secondary-500/30 pointer-events-none absolute top-1/2 left-[5%] size-[160px] -translate-y-1/2 rounded-full blur-[90px]"
      aria-hidden="true"
    />

    <div
      class="relative z-10 mx-auto flex max-w-6xl items-center gap-3 px-4 py-3 text-sm text-white/90"
    >
      <div class="hidden -space-x-2 sm:flex">
        <img
          v-for="a in barAvatars"
          :key="a"
          :src="a"
          alt=""
          loading="lazy"
          class="size-7 rounded-full object-cover ring-2 ring-neutral-900"
        />
      </div>

      <!-- Team owner: their team checkout was never finished — send them back to it -->
      <p v-if="kind === 'owner'">
        Your team doesn't have a paid subscription.
        <InertiaLink
          href="/upgrade_team_plan/new"
          class="font-semibold text-white hover:underline"
        >
          Complete your team plan →
        </InertiaLink>
      </p>

      <!-- Team member: their team's subscription lapsed — they can't fix it personally -->
      <p v-else-if="kind === 'member'">
        Your team doesn't have a paid subscription.
        <InertiaLink
          href="/settings/billing"
          class="font-semibold text-white hover:underline"
        >
          Ask your owner to upgrade, or leave the team →
        </InertiaLink>
      </p>

      <!-- Solo: the upgrade CTA — the whole line is the link, no competing button -->
      <InertiaLink
        v-else
        href="/upgrade_plan/new"
        class="group pr-5 text-balance text-white/90 hover:text-white hover:underline"
        @click="trackButtonClick"
      >
        <!-- One run of text, so a narrow screen wraps it like a sentence. The
             arrow takes no width (the margins cancel it): it never goes to a
             line by itself. -->
        <span class="font-bold">Upgrade to Pro</span>
        to book unlimited 1:1 calls with mentors.
        <ArrowRightIcon
          class="-mr-5 ml-0.5 inline size-3.5 align-[-0.125em] transition-transform group-hover:translate-x-0.5"
        />
      </InertiaLink>
    </div>
  </div>
</template>

<script setup>
import ArrowRightIcon from '~icons/lucide/arrow-right'

// The caller shows this bar for a member with no paid access and names the
// text (useShellNotices): a team owner, a team member, or everybody else.
defineProps({
  kind: { type: String, default: 'solo' },
})

const barAvatars = [
  '/blog-mosaic-faces/eae2ab7c-289b-4ee9-8cfc-9a3552cf9951.webp',
  '/blog-mosaic-faces/ammarah-ahmed.webp',
  '/blog-mosaic-faces/growthgal.webp',
]

const trackButtonClick = () => {
  window.segmentAnalytics.track('Upgrade to Pro link Clicked', {
    user_type: window.segmentAnalytics.userType(),
    link_source: 'Upgrade to pro flash message',
  })
}
</script>
